var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkerFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.197 12.946c.866 0 5.197-4.908 5.197-7.768S8.067 0 5.197 0 0 2.318 0 5.178s4.33 7.768 5.197 7.768m-.001-5.178a2.594 2.594 0 0 0 2.598-2.59 2.593 2.593 0 0 0-2.598-2.589 2.594 2.594 0 0 0-2.599 2.59 2.594 2.594 0 0 0 2.599 2.589",
  clipRule: "evenodd"
})));
export default SvgMarkerFilled;